module.exports = __webpack_public_path__ + "ci_vendor_dynatrace.e9ba0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vendor_dynatrace.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vendor_dynatrace.svg
// module chunks = main